import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface TableAccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function TableAccordion({
  title,
  children,
  defaultOpen = false
}: TableAccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="w-full" data-id="element-189">
      {/* Mobile Accordion Header - Only visible on mobile */}
      <button onClick={() => setIsOpen(!isOpen)} className="md:hidden w-full bg-purple border-brutal border-[#1A1A1A] rounded-none shadow-brutal p-4 mb-4 flex items-center justify-between hover:bg-darkPurple transition-colors duration-100" data-id="element-190">
        <h3 className="font-display text-lg font-bold text-white uppercase tracking-tight text-left" data-id="element-191">
          {title}
        </h3>
        <ChevronDown className={`w-6 h-6 text-yellow transition-transform duration-200 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-192" />
      </button>

      {/* Content - Always visible on desktop, accordion on mobile */}
      <div className={`${isOpen ? 'block' : 'hidden'} md:block`} data-id="element-193">
        {children}
      </div>
    </div>;
}